import React from 'react'
import LayerTop from "./layertop/layerTop";
import LayerPanel from './layerPanel/layerpanel'
export const LayersWrappers = (props) => {
    return (
        <div className="layerWrapper">
            <LayerTop  />
            <LayerPanel/>
        </div>
    )
}
export default LayersWrappers;